/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Email = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 38 23" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M1.65 0A1.66 1.66 0 0 0 0 1.64v19.72A1.66 1.66 0 0 0 1.65 23h34.7A1.66 1.66 0 0 0 38 21.36V1.64A1.66 1.66 0 0 0 36.35 0zm1.41 1.64h31.88l-15.1 12.5a1.55 1.55 0 0 1-1.68 0zm-1.41 1l11.13 9.21-11.13 8.57V2.62zm34.7 0v17.8l-11.13-8.61zM14.07 12.91l3 2.5a3 3 0 0 0 3.8 0l3-2.5 10.93 8.45H3.14z" />
      </g>
    </svg>
  </span>
);

Email.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Email.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Email;
